import styles from "./PointIndication.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const PointIndication = () => /*#__PURE__*/_jsx("div", {
  className: styles.root,
  children: /*#__PURE__*/_jsx("div", {
    className: styles.point
  })
});